import React from "react";

interface CriterionSelectAllProps {
	criterionKey: string;
	quickSearchId: string;
	isVisible: boolean;
	allChecked: boolean;
	onSelectAll: (checked: boolean) => unknown;
}

export default function CriterionSelectAll({
	criterionKey,
	quickSearchId,
	isVisible,
	allChecked,
	onSelectAll,
}: CriterionSelectAllProps) {
	if (!isVisible) {
		return null;
	}

	return (
		<div className="checkbox-input">
			<input
				type="checkbox"
				id={`select_all_${criterionKey}${quickSearchId}`}
				name={`select_all_${criterionKey}`}
				value={`select_all_${criterionKey}`}
				checked={allChecked}
				onChange={(e) => onSelectAll(e.target.checked)}
			/>
			<label htmlFor={`select_all_${criterionKey}${quickSearchId}`}>
				Select all
			</label>
		</div>
	);
}
